<template>
  <div class="banner-text">
    <div class="wrapper"
    :class="{ 'cover': true }"
    :style="{ backgroundImage: 'url(' + firstpicture + ')' }">
      <div class="container"
      :class="{ 'dark': true }">
        <div class="txt">
          <slot name="title">title</slot>
          <slot name="subtitle">subtitle</slot>
          <slot name="content">content</slot>
          <!-- 使用方法
          <bannertext>
            <h1 slot="title">
              這是5rem標題
              <small>這是3rem標題</small>
            </h1>
            <h2 slot="subtitle">這是40px標題</h2>
            <p slot="content">
              Lorem ipsum dolor,sit amet consectetur
              adipisicing elit. Magnam, consequatur!
            </p>
          </bannertext>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    firstpicture: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
    };
  },
};
</script>

<style scoped lang="scss">
.banner-text {
  color: #5a4446;
  width: 100%;
  .wrapper {
    width: 100%;
    height: 400px;
    // background: #fff1c9;
    .container {
      display: flex;
      justify-content: center;
      margin: auto;
      height: 100%;
      .txt {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        text-align: center;
        h1 {
          position: relative;
          font-size: 3.5rem;
          border-bottom: solid 1px;
          padding-bottom: 0.3em;
          margin-bottom: 0.3em;
          small {
            display: block;
            margin-top: 10px;
            font-size: 1.5rem;
          }
        }
      }
    }
  }
}
.cover{
  background-size: cover;
}
.dark {
  background-color: rgba(0, 0, 0, 0.3);
  // color: #000;
  // background: rgb(255, 255, 255);
  color: #fff;
  text-shadow: 3px 2px 10px #000;
}
// 先寫起來
.backgroundpic{
  background-image: url(https://picsum.photos/600/300?random=31);
}
.backgroundcolor{
  background-color: #eea4a4;
}

@media screen and (max-width: 1000px) {
  .banner-text .wrapper {
    .container {
      .txt {
        h1 {
          font-size: 3.5rem;
          small {
            display: block;
            font-size: 3rem;
          }
        }
        h2{
          font-size: 2rem;
        }
      }
    }
  }
}

@media screen and (max-width: 500px) {
  .banner-text .wrapper {
    .container {
      .txt {
        h1 {
          font-size: 3rem;
          small {
            display: block;
            font-size: 2.2rem;
          }
        }
        h2{
          font-size: 1.5rem;
        }
      }
    }
  }
}
</style>
